export enum RouteAidesName {
  AIDES = 'aides',
  VELO = 'aides-velo',
  VELO_FORMULAIRE = 'aides-velo-formulaire',
  AIDE_PREVISUALISATION = 'aide-previsualisation',
  AIDE_CONSULTATION = 'aide-consultation',
}
